module.exports = __webpack_public_path__ + "img/arrow-right.c6bfa5b4.svg";